import { DatePicker } from 'antd';

export function DateRangePicker({ ...props }) {
  return <DatePicker.RangePicker {...props} />;
}
